import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

// Components
import { Images } from './Images';
import { DisplayImage } from './DisplayImage';

export type ImageProps = SliceComponentProps<Content.ImageSlice>;

const Image = ({ slice }: ImageProps) => {
  const { primary, variation } = slice;

  return (
    <>
      {variation === 'default' && (
        <DisplayImage image={primary.image} caption={primary.caption} />
      )}

      {variation === 'withManyImages' && <Images primary={primary} />}
    </>
  );
};

export default Image;
